module.exports = __webpack_public_path__ + "static/media/BMW_White_Logo.96387f85.svg";